export const DEFAULT_EMPTY_Y_AXIS_TICKS = [0, 20, 40, 60, 80, 100] as const;

export const DEFAULT_Y_AXIS_DESIRED_STEPS = 14;

export const Y_AXIS_DESIRED_STEPS_BY_LEVEL: Record<number, number> = {
    1: 14,
    2: 8,
    3: 4,
    4: 4,
};

export const LEVEL3_SMALL_RANGE_Y_AXIS = {
    max: 0.1,
    ticks: Array.from({ length: 10 }, (_, index) => Number(((index + 1) * 0.01).toFixed(2))),
} as const;

// Switch between showing every year on x-axis or every 5th year (for EmissionsChart and MarketChart)
export const SHOW_X_AXIS_EVERY_5_YEARS = true;

export const X_AXIS_YEAR_STEP = SHOW_X_AXIS_EVERY_5_YEARS ? 5 : 1;
export const X_AXIS_FIRST_YEAR = 2022;
export const X_AXIS_FIRST_FIVE_YEAR_TICK = 2025;

// Recharts XAxis interval: 0 = show every tick, 4 = show every 5th tick.
export const X_AXIS_YEAR_INTERVAL = X_AXIS_YEAR_STEP - 1;

export const shouldShowXAxisYear = (year: number) => {
    if (!Number.isFinite(year)) {
        return false;
    }

    if (!SHOW_X_AXIS_EVERY_5_YEARS) {
        return true;
    }

    return (
        year === X_AXIS_FIRST_YEAR ||
        (year >= X_AXIS_FIRST_FIVE_YEAR_TICK && (year - X_AXIS_FIRST_FIVE_YEAR_TICK) % 5 === 0)
    );
};

export const buildXAxisYears = (years: number[]) => years.filter((year) => shouldShowXAxisYear(year));

export const TOOLTIP_OFFSET = 80;
